import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import logoIcon from "../assets/Logo.png";
import { useAuth } from "../App";

function Navbar() {
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const scrollTo = (id) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className={`nb ${scrolled ? "nb--scrolled" : ""}`}>
      <div className="nb-inner">
        {/* Brand */}
        <Link to="/" className="nb-brand" onClick={() => scrollTo("home")}>
          <img src={logoIcon} alt="AiDuNode" className="nb-logo" />
          <span className="nb-brand-name">AiDuNode</span>
        </Link>

        {/* Desktop nav */}
        <nav className="nb-nav">
          <button className="nb-link" onClick={() => scrollTo("home")}>Beranda</button>
          <button className="nb-link" onClick={() => scrollTo("features")}>Fitur</button>
        </nav>

        {/* Desktop actions */}
        <div className="nb-actions">
          {user ? (
            <>
              <Link to="/dashboard" className="nb-btn-outline">
                🏠 Dashboard
              </Link>
              <Link to="/profil" className="nb-avatar-pill">
                <span className="nb-avatar">{user.name?.[0]?.toUpperCase()}</span>
                <span>{user.name?.split(" ")[0]}</span>
              </Link>
            </>
          ) : (
            <>
              <Link to="/admin/login" className="nb-btn-admin">🛡️ Admin</Link>
              <Link to="/login" className="nb-btn-outline">Masuk</Link>
              <Link to="/register" className="nb-btn-primary">Mulai Gratis ↗</Link>
            </>
          )}
        </div>

        {/* Hamburger */}
        <button
          className={`nb-ham ${menuOpen ? "open" : ""}`}
          aria-label="Toggle menu"
          onClick={() => setMenuOpen((v) => !v)}
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`nb-mobile ${menuOpen ? "open" : ""}`}>
        <button className="nb-mobile-link" onClick={() => scrollTo("home")}>Beranda</button>
        <button className="nb-mobile-link" onClick={() => scrollTo("features")}>Fitur</button>
        <div className="nb-mobile-divider" />
        {user ? (
          <>
            <Link to="/dashboard" className="nb-mobile-btn primary" onClick={() => setMenuOpen(false)}>🏠 Dashboard</Link>
            <button className="nb-mobile-btn outline" onClick={() => { handleLogout(); setMenuOpen(false); }}>Keluar</button>
          </>
        ) : (
          <>
            <Link to="/login"       className="nb-mobile-btn outline" onClick={() => setMenuOpen(false)}>Masuk</Link>
            <Link to="/register"    className="nb-mobile-btn primary" onClick={() => setMenuOpen(false)}>Mulai Gratis</Link>
            <Link to="/admin/login" className="nb-mobile-btn admin"  onClick={() => setMenuOpen(false)}>🛡️ Login Admin</Link>
          </>
        )}
      </div>
    </header>
  );
}

export default Navbar;